import React from "react";
const GalleryList = (props : { imageUrl?:string | undefined, imageName : string,onDelete : ()=>void }) => {
  return (
    <div className="item-img-upload overflow-hidden position-relative">
      <img src={props?.imageUrl} alt="img" className="img-fluid h-100 w-100" />
      <span className="strap d-block position-absolute d-inline-block d-inline-block text-uppercase text-white font-weight-semibold">
        {props.imageName}
      </span>

      <span className="delete d-flex justify-content-center align-items-center position-absolute rounded-circle cursor-pointer" onClick={props.onDelete}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="11"
          viewBox="0 0 9 11"
          fill="none"
        >
          <path
            d="M2.27388 11C1.85617 11 1.50262 10.8541 1.21322 10.5622C0.923814 10.2704 0.779112 9.91388 0.779112 9.49266V2.24486H0.620148C0.444439 2.24486 0.29712 2.18489 0.178189 2.06496C0.0593963 1.94503 0 1.79647 0 1.61928C0 1.44196 0.0593963 1.29347 0.178189 1.17381C0.29712 1.05402 0.444439 0.994125 0.620148 0.994125H3.14828V0.737516C3.14828 0.533369 3.2196 0.359447 3.36223 0.215751C3.50487 0.0719167 3.67741 0 3.87985 0H5.12015C5.32259 0 5.49513 0.0719167 5.63776 0.215751C5.78026 0.359447 5.85151 0.533369 5.85151 0.737516V0.994125H8.37985C8.55556 0.994125 8.70281 1.05409 8.8216 1.17402C8.94053 1.29395 9 1.44251 9 1.6197C9 1.79703 8.94053 1.94552 8.8216 2.06517C8.70281 2.18496 8.55556 2.24486 8.37985 2.24486H8.22089V9.49266C8.22089 9.91388 8.07619 10.2704 7.78678 10.5622C7.49738 10.8541 7.14383 11 6.72612 11H2.27388Z"
            fill="white"
          />
        </svg>
      </span>
    </div>
  );
};

export default GalleryList;
